export default "__VITE_ASSET__DskZ3R7$__"